import "../../index23.css";
import { jsx as s } from "react/jsx-runtime";
import { useMemo as u } from "react";
import { _ as p } from "../../cs-piwRuCFZ.js";
import "../../type-BFTbooL7.js";
import { j as i } from "../../common-UUpiO33D.js";
const c = "_date-output_4jzjo_1", d = {
  dateOutput: c
};
function v(a) {
  const {
    value: t,
    format: o,
    className: e,
    invalidText: r
  } = a, m = u(
    () => i(
      t,
      o
    ),
    [t, o]
  );
  return /* @__PURE__ */ s("div", { className: p(d.dateOutput, e), children: m ?? r });
}
export {
  v as default
};
